import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      image: '/img/testimonial-1.png',
      name: 'Vanessa B.',
      text: 'I was craving a smoothie and found this little gem. This place has SO many smoothie options. I tasted the smoothie and instantly fell in love. Everytime I took a sip it melted in my mouth. It was sweet and organic omgggg !! Can’t wait to come back. This might be my new smoothie spot. I’ve never had an açai bowl before so I’m hoping this is just as good as the smoothie!'
    },
    {
      image: '/img/testimonial-2.png',
      name: 'Janet Hernandez',
      text: 'Very tasty high quality smoothies. I brought my daughter here, she and I both loved it. I also got their one of a kind cookies, so healthy Paleo cookies just what I needed - the staff was super friendly. Will definitely be coming back'
    },
    {
      image: '/img/testimonial-3.png',
      name: 'Tatyana Telegina',
      text: 'I really liked this place and happy I have discovered it. I’m a vegan, healthy foods junkie, and so I carefully examine places like this. Chris, the owner, is a very sweet guy and he makes his juices and other food items with love, creativity and overall ‘soul’, which isn’t very common/easy to find!! I really liked the dragonfruit smoothie bowl I got there. It was maybe a tiny bit too sweet for my personal preference, but very good, nonetheless. Next time I’ll just ask for less honey, that’s all. The smoothies themselves were super delicious. Chris brought me some just to try for free, which was so sweet of him. I will certainly be back there:) I’m excited to try other items he has on the menu. Lovely place.'
    },
    {
      image: 'placeholder',
      name: 'Zeyad Andrew Hady',
      text: "I made sure to come here at least three times before leaving a review. I must say, each and every time I was more and more impressed. The food selection is limited but I believe they've chosen quality over quantity as every single food item I've tried was incredibly delicious, fresh and healthy. The owner is usually there and is extremely friendly and open to answering any questions in regards to ingredients and benefits. He is very friendly and consistent when it comes to the food and drinks. I highly recommend this place. I could eat here 7 days a week."
    }
  ];

  return (
    <div className="container-fluid bg-light bg-icon py-6 mb-5">
      <div className="container">
        <div className="section-header text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: '500px'}}>
          <h1 className="display-5 mb-3">Customer Reviews</h1>
          <p>Hear what our customers have to say about their experience at Organique Juice Bar—fresh, healthy, and delicious every time.</p>
        </div>
        <div className="row g-4">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="col-lg-6 col-md-6">
              <div className="testimonial-item position-relative bg-white p-5 mt-4">
                <i className="fa fa-quote-left fa-3x text-brand position-absolute top-0 start-0 mt-n4 ms-5"></i>
                <p className="mb-4">{testimonial.text}</p>
                <div className="d-flex align-items-center">
                  {testimonial.image.startsWith('http') || testimonial.image.startsWith('/img/testimonial-') ? (
                    <img className="flex-shrink-0 rounded-circle" src={testimonial.image} alt={testimonial.name} style={{width: '60px', height: '60px', objectFit: 'cover'}} />
                  ) : (
                    <div className="flex-shrink-0 rounded-circle d-flex align-items-center justify-content-center" style={{width: '60px', height: '60px', backgroundColor: 'var(--primary)', color: 'white', fontSize: '24px', fontWeight: 'bold'}}>
                      {testimonial.name.charAt(0)}
                    </div>
                  )}
                  <div className="ms-3">
                    <h5 className="mb-1">{testimonial.name}</h5>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;